import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getEventDelayCodes = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-delay-codes`);
    return response.data;
  } catch (error) {
    console.error('Error fetching event delay codes:', error.response?.data || error);
    throw error;
  }
};

export const getEventDelayCodeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-delay-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching event delay code:', error.response?.data || error);
    throw error;
  }
};

export const createEventDelayCode = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/event-delay-codes`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating event delay code:', error.response?.data || error);
    throw error;
  }
};

export const updateEventDelayCode = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/event-delay-codes/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating event delay code:', error.response?.data || error);
    throw error;
  }
};

export const deleteEventDelayCode = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/event-delay-codes/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting event delay code:', error.response?.data || error);
    throw error;
  }
};
